<template>
    <div class="c-command-right">
        <YScroll class="full-height">
            <div class="c-command-right__content">
                <div class="c-command-right__item1">
                    <EnvironmentTitle title-class="title-white"
                        :TxtUnit="[$t('yingji.rightAside.emergencyPersonnelStat')]" />
                    <div class="c-command-right__itemContent content-width">
                        <div class="stat-title">
                            <span class="stat-label">{{ $t('yingji.rightAside.emergencyTeamStat') }}</span>
                            <span class="stat-total">{{ $t('yingji.rightAside.total') }} <i class="total-number">{{
                                    teamStatTotals }}</i></span>
                        </div>
                        <IconTitle :IconNameTxt="teamStat" :width="100"></IconTitle>
                        <div class="stat-title stat-title--no-margin">
                            <span class="stat-label">{{ $t('yingji.rightAside.emergencyPersonnelStat') }}</span>
                            <span class="stat-total">{{ $t('yingji.rightAside.total') }} <i class="total-number">{{
                                    personnelStatTotals }}</i></span>
                        </div>
                        <div class="bottom-margin">
                            <IconTitle :width="100" :IconNameTxt="personnelStat"></IconTitle>
                        </div>
                    </div>
                </div>
                <!-- <div class="c-command-right__item1">
                    <EnvironmentTitle title-class="title-white" :TxtUnit="[$t('yingji.rightAside.droneStat')]"><span
                            class="total-badge">{{ $t('yingji.rightAside.total') }}&nbsp;<i class="total-number">{{
                                vehicleStatTotals
                                }}</i></span></EnvironmentTitle>
                    <div class="c-command-right__itemContent content-width">
                        <div class="bottom-margin">
                            <IconTitle :width="100" :IconNameTxt="vehicleStat"></IconTitle>
                        </div>
                    </div>
                </div> -->
                <div class="c-command-right__item2">
                    <EnvironmentTitle title-class="title-white" :TxtUnit="[$t('yingji.rightAside.deviceStat')]"><span
                            class="total-badge">{{ $t('yingji.rightAside.total') }}&nbsp;<i class="total-number">{{
                                deviceTotals
                                }}</i></span></EnvironmentTitle>
                    <div class="c-command-right__item2-equipment">
                        <template v-if="deviceStat.length === 0">
                            <div class="c-command-right__empty">
                                {{ $t('yingji.rightAside.noData') }}
                            </div>
                        </template>
                        <template v-else>
                            <el-row :gutter="0" v-for="(item, index) in deviceStat" :key="index" class="device-row">
                                <el-col :span="7" class="device-name">{{ item.system }}</el-col>
                                <el-col :span="5" class="device-item">
                                    <span class="device-label">{{ $t('yingji.rightAside.free') }}</span>
                                    <span class="device-value">{{ item['空闲'] }}</span>
                                </el-col>
                                <el-col :span="6" class="device-item">
                                    <span class="device-label">{{ $t('yingji.rightAside.working') }}</span>
                                    <span class="device-value">{{ item['工作中'] }}</span>
                                </el-col>
                                <el-col :span="6" class="device-item last">
                                    <span class="device-label">{{ $t('yingji.rightAside.repair') }}</span>
                                    <span class="device-value">{{ item['维修中'] }}</span>
                                </el-col>
                            </el-row>
                        </template>
                    </div>
                </div>
                <div class="c-command-right__item3">
                    <EnvironmentTitle title-class="title-white" :TxtUnit="[$t('yingji.rightAside.carStat')]"><span
                            class="total-badge">{{ $t('yingji.rightAside.total') }}&nbsp;<i class="total-number">{{
                                carStatTotals
                                }}</i></span></EnvironmentTitle>
                    <PieBuild :pieList="pieArr" class="pie-height" @changeItem="changeItem"></PieBuild>
                </div>
            </div>
        </YScroll>
    </div>
</template>

<script>
import { YScroll } from '@CommonComponent';
import topTabs from '@/components/topTabs.vue';
import EnvironmentTitle from '@/page/environmental/common/EnvironmentTitle.vue';
import IconTitle from '@/page/environmental/common/IconTitle.vue';
import PieBuild from '@/page/environmental/components/right/components/PieBuild.vue';
import api from '@/page/business/yingji/api/index.js';

export default {
    components: { topTabs, EnvironmentTitle, IconTitle, PieBuild, YScroll },
    data () {
        return {
            tabsObj: {
                centre: this.$t('yingji.rightAside.dataStatistics'),
                type: 3,
            },
            date: '',
            pieArr: [
                { nameKey: 'yingji.rightAside.standby', count: 0, id: '1', color: '#48f3fe', value: 0 },
                { nameKey: 'yingji.rightAside.working', count: 0, id: '2', color: '#4773fd', value: 0 },
                { nameKey: 'yingji.rightAside.exception', count: 0, id: '3', color: '#f08200', value: 0 },
            ],
            currentPEvent: null,
            deviceTotals: 0, // 挂载统计总数
            teamStatTotals: 0, // 应急队伍统计总数
            personnelStatTotals: 0, // 应急人员统计总数
            vehicleStatTotals: 0, // 无人机总数
            carStatTotals: 0, // 车辆总数

            teamStat: [
                {
                    nameKey: 'yingji.rightAside.working',
                    IconName: 'main_right_p1',
                    num: 0,
                },
                {
                    nameKey: 'yingji.rightAside.standby',
                    IconName: 'main_right_p1',
                    num: 0,
                },
            ],
            personnelStat: [
                {
                    nameKey: 'yingji.rightAside.standby',
                    IconName: 'main_right_p1',
                    num: 0,
                },
                {
                    nameKey: 'yingji.rightAside.leave',
                    IconName: 'main_right_p1',
                    num: 0,
                },
                {
                    nameKey: 'yingji.rightAside.working',
                    IconName: 'main_right_p1',
                    num: 0,
                },
            ],
            vehicleStat: [
                {
                    nameKey: 'yingji.rightAside.online',
                    IconName: 'main_right_p1',
                    num: 0,
                },
                {
                    nameKey: 'yingji.rightAside.offline',
                    IconName: 'main_right_p1',
                    num: 0,
                },
                {
                    nameKey: 'yingji.rightAside.working',
                    IconName: 'main_right_p1',
                    num: 0,
                },
            ],
            deviceStat: [], // 挂载统计
        };
    },
    created () {
        this.teamStat.forEach((item) => {
            item.name = this.$t(item.nameKey);
        });
        this.personnelStat.forEach((item) => {
            item.name = this.$t(item.nameKey);
        });
        this.vehicleStat.forEach((item) => {
            item.name = this.$t(item.nameKey);
        });
        this.pieArr.forEach((item) => {
            item.name = this.$t(item.nameKey);
        });

        Promise.all([
            this.getCarStatistic(),
            this.getDroneStatistic(),
            this.getDeviceStatistic(),
            this.getTeamStatistic(),
            this.getTeamUserStatistic(),
        ]).catch(() => { });
    },
    methods: {
        // 获取车辆统计数据
        async getCarStatistic () {
            let res = await api.getCarStatistic();
            // console.log('getCarStatistic', res.data);
            if (res.code === 200) {
                const { total, items } = this.processStatList(res.data);
                this.carStatTotals = total;
                this.pieArr = items.map((item) => ({
                    nameKey: `yingji.rightAside.${item.code}`,
                    name: this.$t(`yingji.rightAside.${item.code}`),
                    count: item.value || 0,
                    id: item.code,
                    color: item.code === 'standby' ? '#48f3fe' : (item.code === 'working' ? '#4773fd' : '#f08200'),
                    value: 0,
                }));
            } else {
                this.$message.error(res.msg);
            }
        },

        // 获取无人机统计数据
        async getDroneStatistic () {
            let res = await api.getDroneStatistic();

            // console.log('getDroneStatistic', res.data);
            if (res.code === 200) {
                const { total, items } = this.processStatList(res.data);
                this.vehicleStatTotals = total;
                this.vehicleStat = items.map((item) => ({
                    nameKey: `yingji.rightAside.${item.code}`,
                    name: this.$t(`yingji.rightAside.${item.code}`),
                    IconName: 'main_right_p1',
                    num: item.value || 0,
                }));
            } else {
                this.$message.error(res.msg);
            }
        },

        // 获取挂载统计数据
        async getDeviceStatistic () {
            let res = await api.getDeviceStatistic();
            // console.log('getDeviceStatistic', res.data);
            if (res.code === 200) {
                let list = res.data;
                let totals = 0;
                if (!list || !Array.isArray(list) || list.length === 0) {
                    this.deviceTotals = 0;
                    this.deviceStat = [];
                    return;
                }
                const { total, items } = this.processStatList(list);
                totals = total;
                this.deviceTotals = totals;
                this.deviceStat = items.map((item) => ({
                    ...item,
                    system: item.name,
                    维修中: item.repair || 0,
                    空闲: item.idle || 0,
                    工作中: item.work || 0,
                }));
            } else {
                this.$message.error(res.msg);
            }
        },
        // 获取应急队伍统计数据
        async getTeamStatistic () {
            let res = await api.getTeamStatistic();

            // console.log('getTeamStatistic', res.data);
            if (res.code === 200) {
                const { total, items } = this.processStatList(res.data);
                this.teamStatTotals = total;
                this.teamStat = items.map((item) => ({
                    nameKey: `yingji.rightAside.${item.code}`,
                    name: this.$t(`yingji.rightAside.${item.code}`),
                    IconName: 'main_right_p1',
                    num: item.value || 0,
                }));
            } else {
                this.$message.error(res.msg);
            }
        },
        // 获取应急人员统计数据
        async getTeamUserStatistic () {
            let res = await api.getTeamUserStatistic();

            // console.log('getTeamStatistic', res.data);
            if (res.code === 200) {
                const { total, items } = this.processStatList(res.data);
                this.personnelStatTotals = total;
                this.personnelStat = items.map((item) => ({
                    nameKey: `yingji.rightAside.${item.code}`,
                    name: this.$t(`yingji.rightAside.${item.code}`),
                    IconName: 'main_right_p1',
                    num: item.value || 0,
                }));
            } else {
                this.$message.error(res.msg);
            }
        },
        // 处理带 total 的统计数组，抽取共用逻辑
        processStatList (list) {
            if (!list || !Array.isArray(list) || list.length === 0) {
                return { total: 0, items: [] };
            }
            const totalItem = list.find((item) => item.code === 'total');
            const total = totalItem ? (totalItem.value || 0) : 0;
            const items = list.filter((item) => item.code !== 'total');
            return { total, items };
        },
        changeItem (item) {
            this.currentPEvent = item;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';

::-webkit-scrollbar {
    width: 5px;
    /*滚动条宽度*/
    background-color: transparent;
}

::-webkit-scrollbar-thumb {
    background-color: rgba(144, 147, 153, 0.3);
}

@include b(command-right, c) {
    height: 100%;

    @include e(content) {
        padding: 15px 17px 0 15px;
        // overflow-y: overlay;
        // &:hover {
        //     &::-webkit-scrollbar-thumb {
        //         background-color: rgba(144, 147, 153, 0.3);
        //     }
        // }
    }

    @include e(time) {
        margin-bottom: 18px;
    }

    @include e(item1) {
        @include e(itemContent) {
            position: relative;
            // height: 172px;

            .stat-title {
                height: 25px;
                margin-top: 12px;
                padding-left: 5px;
                color: #e6f7ffff;
                font-size: 14px;
                background: url('./imgs/title-bg.png') no-repeat left bottom;
                background-size: 55% 40%;
                display: flex;
                // justify-content: space-between;
                align-items: center;

                &.stat-title--no-margin {
                    margin: 0;
                }

                .stat-label {
                    color: #e6f7ffff;
                }

                .stat-total {
                    color: #fff;
                    font-size: 14px;
                    margin-left: 30px;
                    i {
                        font-style: normal;
                    }
                }
            }
        }
    }

    @include e(item2) {
        @include e(item2-equipment) {
            margin: 20px 0;
            color: #fff;
            font-size: 14px;
            line-height: 30px;

            .c-command-right__empty {
                width: 100%;
                text-align: center;
                padding: 30px 0;
                color: rgba(255, 255, 255, 0.6);
            }

            .device-row {
                line-height: 32px;
            }

            .device-name {
                color: #fff;
                font-size: 14px;
            }

            .device-item {
                color: #ffffff99;
                font-size: 14px;
                text-align: center;

                &.last {
                    padding-right: 0;
                }

                .device-label {
                    margin-right: 4px;
                }
            }

            .device-value {
                color: #49f0fdff;
                font-weight: 500;
            }
        }
    }

    @include e(item3) {
        margin-top: 12px;
    }

    .full-height {
        height: 100%;
    }

    .content-width {
        width: 305px;
    }

    .bottom-margin {
        margin-bottom: 20px;
    }

    .title-white {
        color: #fff;
        -webkit-text-fill-color: #fff;
    }

    .total-badge {
        position: absolute;
        right: 20px;
        color: #fff;
        font-size: 14px;
    }

    .total-number {
        color: #49f0fdff;
        font-size: 18px;
    }

    .pie-height {
        height: 150px;
    }
}
</style>
